import { Component, Input } from '@angular/core';
import {
    databaseChartEmptyMessage, databaseChartTitle, poolChartTitle, poolEmptyMessage
} from '../_helpers/platform-health-metrics';
import { AppInsightsBlock, DatabaseBlock, PlatformBlock } from '../_types/platform-health';

/// Pestaña "Visión global": la historia conjunta del panel, con la fila de indicadores completa y
/// las tres gráficas que comparten el eje de tiempo (Tráfico y errores, Tiempo de respuesta, Base de
/// datos). Componente de presentación puro: no pide datos, no construye gráficas, no conoce el
/// servicio. Todo llega ya resuelto desde PlatformHealthDashboardComponent.
@Component({
    selector: 'app-platform-health-overview',
    templateUrl: './platform-health-overview.component.html',
    styleUrls: ['./platform-health-overview.component.scss'],
    standalone: false
})
export class PlatformHealthOverviewComponent {
    @Input() public canSeeInfrastructure = false;
    @Input() public canSeeDatabase = false;

    @Input() public platform: PlatformBlock | null = null;
    @Input() public database: DatabaseBlock | null = null;
    @Input() public appInsights: AppInsightsBlock | null = null;

    @Input() public trafficChart: any = null;
    @Input() public latencyChart: any = null;
    @Input() public databaseChart: any = null;
    @Input() public poolChart: any = null;

    @Input() public chartOptions: any = null;
    @Input() public trafficChartOptions: any = null;

    public databaseChartTitle(): string {
        return databaseChartTitle(this.database);
    }

    public databaseChartEmptyMessage(): string {
        return databaseChartEmptyMessage(this.database);
    }

    public poolChartTitle(): string {
        return poolChartTitle(this.database);
    }

    public poolEmptyMessage(): string {
        return poolEmptyMessage(this.database);
    }
}
